import React from 'react';

const TypingIndicator: React.FC = () => {
  return (
    <div className="flex items-center space-x-1">
      <span className="w-1.5 h-1.5 bg-muted-foreground rounded-full animate-bounce-1"></span>
      <span className="w-1.5 h-1.5 bg-muted-foreground rounded-full animate-bounce-2"></span>
      <span className="w-1.5 h-1.5 bg-muted-foreground rounded-full animate-bounce-3"></span>
    </div>
  );
};

export default TypingIndicator;